import { EntityState, getEntityType } from '@datorama/akita';
import { AbstractEntityStore, Entity } from './abstract-entity.store';

export interface UiEntityState extends EntityState {
    ui: any
}

export class AbstractUiEntityStore<S extends EntityState | UiEntityState = any, EntityType extends Entity = getEntityType<S>> extends AbstractEntityStore<S, EntityType> {
    updateUi(newState: Partial<S['ui']>): void {
        this.update({
            // ...this._value(),
            ui: {
                ...this._value().ui,
                ...newState
            }
        } as S)
    }
}